export default {
  userHasRole: (state) => (role) => (state.user.roles || []).includes(role),
  editingMe: (state, getters, rootState, rootGetters) =>
    rootGetters.userId === state.userId,
}
